<template>
  <div>
    <div v-if="solution.isVisible">
      <!--  Mobile view -->
      <div class="is-flex is-justify-content-space-between">
        <div>
          <div class="columns is-mobile">
            <!-- AIRLINE LOGO -->
            <div class="column is-narrow has-text-centered wrap">
              <div class="mt-1 airlineLogo">
                <img
                  width="20"
                  :src="$helpers.airlineLogo(solution.airlineCode, 20, 20)"
                />
              </div>
            </div>
            <!-- FROM-TO -->
            <div class="column is-narrow">
              <div class="journeys-summary-container">
                <JourneySummaryAlt
                  v-for="(journey, journeyIndex) in solution.journeys"
                  :key="journeyIndex"
                  :journey="journey"
                  :index="journeyIndex"
                />
              </div>

              <div v-if="ndcFare" class="mb-3">
                <div v-if="solution.travelPolicy" class="is-block">
                  <NDCTag class="mt-3" position="is-left"></NDCTag>
                </div>

                <div v-if="solution.travelPolicy" class="is-block">
                  <OutOfPolicyTag
                    class="mr-1"
                    :travelPolicy="solution.travelPolicy"
                  ></OutOfPolicyTag>
                </div>

                <div v-if="isPreferredVendor" class="is-block">
                  <PreferredVendorTag
                    class="mr-1"
                    type="air"
                  ></PreferredVendorTag>
                </div>

                <div
                  class="is-block"
                  v-if="
                    solution.journeys[0] &&
                      unusedTickets.includes(solution.journeys[0].airlineCode)
                  "
                >
                  <b-tag type="is-info is-light">
                    <b-icon icon="currency-usd" size="is-small"></b-icon>
                    <span>Unused Ticket</span>
                  </b-tag>
                </div>

                <!-- Immediate travel -->
                <div v-if="solution.immediateTravelBookingAdvice">
                  <ImmediateTravelNote
                    :severity="solution.immediateTravelBookingAdvice"
                    class="mb-2"
                  />
                </div>
                <!-- End Immediate travel -->
              </div>
            </div>
          </div>
        </div>
        <div>
          <div v-if="useAtcShopper" class="mb-4">

            <div class="has-text-weight-bold is-size-7 has-text-right"> Total Due</div>
          
            <div
            v-if="solution.pricing.totalDifference > 0"
            class=" has-text-danger is-size-6 has-text-weight-bold has-text-right"
          >
            <div>+{{ solution.pricing.totalDue | formatPriceFromAmount }}</div>
          </div>

          <div
            v-else
            class=" is-size-6 has-text-right"
          >
            <div class="has-text-weight-bold">{{ solution.pricing.totalDue | formatPriceFromAmount }}</div>

            <div class="is-size-7 has-text-right has-text-grey"> Residual Value</div>
            <div class="has-text-success has-text-weight-normal">
              ({{ solution.pricing.residualValue | formatPriceFromAmount }})
            </div>
          </div>

          </div>
          <div v-else class="has-text-right mr-2">
            <span class="has-text-grey-dark is-size-6 has-text-weight-bold">
              {{ solution.pricing.total | formatPriceFromAmount(0, solution.pricing.currencyCode) }}
            </span>
          </div>
          <div class="score-container has-text-right is-size-7">
            <div class="">
              <!-- $popper Tooltip -->
              <section class="is-inline-block ml-1 mr-2">
                <div ref="topArrow">
                  <span
                    class="score is-clickable"
                    :class="scoreClass"
                    @mouseenter="
                      $popper.togglePopper($refs.topArrow, $refs.topMenu)
                    "
                    @mouseleave="
                      $popper.togglePopper($refs.topArrow, $refs.topMenu)
                    "
                  >
                    <span class="score-numerator inner-circle">{{
                      scoreOutOfTen
                    }}</span>
                  </span>
                </div>
                <div
                  ref="topMenu"
                  class="filterBox popper-popup"
                  style="background: #eee; max-width: 200px;"
                >
                  <p class="is-size-7">
                    Rating is based on price, travel duration, company
                    preferences, and travel preferences.
                  </p>
                  <div class="popper-arrow"></div>
                </div>
              </section>
            </div>
          </div>
          <!-- FARE RULES (One-Way Only) -->
          <div class="has-text-right mr-2" v-if="isOneWay">
            <div
              class="is-clickable"
              @click="fareRulesModal(solution.journeys)"
            >
              <b-icon
                icon="alpha-f-circle"
                size="is-default"
                class="has-text-grey-lighter"
              >
              </b-icon>
            </div>
          </div>

          <!-- Fare Upsell Options -->
          <div v-if="solution.upsellsCount > 0" class="mt-4">
            <div class="is-size-7 has-text-weight-semibold">Fare Option:</div>
            <div class="is-size-7 has-text-grey">
              {{ fareDescription }}
            </div>

            <div
              class="has-text-primary is-clickable is-size-7"
              @click="$emit('show-fare-options')"
            >
              More fare options
            </div>
          </div>
        </div>
      </div>

      <div class="is-flex is-justify-content-center">
        <!-- FLIGHT INFO -->
        <div class="">
          <div class="is-flex">
            <div
              class="is-inline-block mr-1 is-clickable"
              @click="$emit('display')"
            >
              <!--              <b-icon-->
              <!--                  icon="information"-->
              <!--                  size="is-default"-->
              <!--                  class="has-text-grey-lighter"-->
              <!--              />-->
              <b-button type="is-outlined" size="is-small"
                >View Details</b-button
              >
            </div>
          </div>
        </div>
        <div class="">
          <div class="is-flex">
            <div
              class="is-inline-block is-clickable"
              v-if="
                solution.isSelectable &&
                  !isPrevented
              "
              style="width: 70px;"
            >
              <b-button
                type="is-primary"
                size="is-small"
                @click="checkSubmission()"
                >Book</b-button
              >
            </div>

            <div
              v-if="!solution.isSelectable"
              class="is-size-7 has-text-grey is-block"
            >
              Not selectable
            </div>

            <div
              v-if="
                solution.isSelectable &&
                  isPrevented
              "
              class="notification is-size-7 has-text-grey has-text-centered"
            >
              To book this option call: <br />
              877-924-0303
            </div>
          </div>
        </div>
      </div>
      <!--  end of Mobile view -->
    </div>
  </div>
</template>

<script>
import SeatMapMenu from "../../SeatMap/SeatMapMenu.vue";
import JourneySummaryAlt from "./JourneySummaryAlt";
import meetingsMixin from "../../../mixins/meetingsMixin";
import modalMixin from "../../../mixins/modalMixin";
import bookingMixin from "../../../mixins/bookingMixin";
import OutOfPolicyTag from "../../Tags/OutOfPolicyTag.vue";
import ImmediateTravelNote from "../../Traveller/ImmediateTravelNote";
import PreferredVendorTag from "../../Tags/PreferredVendorTag.vue";
import NDCTag from "../../Tags/NDCTag.vue";

export default {
  name: "ResultByPriceMobileView",
  mixins: [meetingsMixin, modalMixin, bookingMixin],
  components: {
    JourneySummaryAlt,
    OutOfPolicyTag,
    ImmediateTravelNote,
    PreferredVendorTag,
    NDCTag,
  },
  props: {
    solution: {},
    first_selected: Boolean,
    tripVal: Number,
    preferredVendors: Array,
  },
  data: function() {
    return {
      display_full: false,
      path: "",
      time: "",
      price: "",
      score: "",
      stops: [],
      scoreOptions: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
      isDesktop: true,
    };
  },
  computed: {
    originalFare() {
      return this.$store.state.bookTravel?.atc?.price || null;
    },
    newFare() {
      return Number(this.solution.pricing.total) || 0;
    },
    residualValue() {
      return Number(this.solution.pricing.residualValue);
    },
    lostValue() {
      return this.originalFare - this.newFare - this.residualValue;
    },
    isPrevented() {
      let prevented = false;
      if (this.solution.immediateTravelBookingAdvice == "prevent") {
        prevented = true;
      }
      if (this.lostValue > 200) {
        prevented = true;
      }
      return prevented;
    },
    ndcFare() {
      return this.solution.offer != null;
    },
    useAtcShopper() {
      return this.$store.state.bookTravel.atc?.useAtcShopper;
    },
    unusedTickets() {
      if (this.pathMixin_isMeeting) {
        return [];
      }
      if (
        this.$store.getters["travellersAndTrips/getCurrentTravellerProfile"]
          .unusedTicketAirlines
      ) {
        return this.$store.getters[
          "travellersAndTrips/getCurrentTravellerProfile"
        ].unusedTicketAirlines;
      } else {
        return [];
      }
    },
    roundTripDifferentAirports(journeyIndex) {
      if (this.tripVal == 1) {
        return (
          this.solution.journeys[0].from != this.solution.journeys[1].to ||
          this.solution.journeys[0].to != this.solution.journeys[1].from
        );
      }
      return false;
    },
    triggerMessages() {
      var message = "";
      for (
        let i = 0;
        i < this.solution.travelPolicy.rulesTriggered.length;
        i++
      ) {
        message +=
          this.solution.travelPolicy.rulesTriggered[i].message + "  |  ";
      }
      return message;
    },
    scoreOutOfTen() {
      return this.$options.filters.displayScore(this.solution.score);
    },
    scoreClass() {
      return (
        "score-" + this.scoreOutOfTen + " outer-circle-" + this.scoreOutOfTen
      );
    },
    scoreOptionClass() {
      return "score-bar-" + this.scoreOutOfTen;
    },
    activeScoreBarClass() {
      return "active-score-bar";
    },
    flightForItinerary() {
      var sol = this.solution;
      sol.unusedTicket = this.unusedTickets.includes(
        sol.journeys[0].airlineCode
      );
      for (var i = 0; i < sol.journeys.length; i++) {
        // console.log(i)
        for (var j = 0; j < sol.journeys[i].legs.length; j++) {
          // console.log(j)
          sol.journeys[i].legs[j].selectedSeat = false;
        }
      }
      return sol;
    },
    solutionAirlineCodes() {
      var airlines = [];

      for (let journey of this.solution.journeys) {
        airlines.push(journey.airlineCode);
      }

      return airlines;
    },
    solutionAirlineNames() {
      var airlineNames = [];

      for (let airlineCode of this.solutionAirlineCodes) {
        airlineNames.push(this.$globals.airlineNames[airlineCode]);
      }

      return airlineNames;
    },
    isPreferredVendor() {
      return this.solution.isPreferred;
      //return this.preferredVendors.includes(this.solution.airlineCode);
    },
    fareDescription() {
      return this.solution.fareFamily?.familyDescription || "";
    },
  },
  methods: {
    filterByFlight(val) {
      this.display_full = false;
      this.$emit("filter", val);
    },
    async flightSelected() {
      this.$store
        .dispatch("bookTravel/alterResult", this.solution)
        .then(this.$router.push({ path: "/itinerary" }));
    },
    display() {
      this.display_full = !this.display_full;
      //// console.log('called display()');
    },
    getAirportLocation(airportCode) {
      let airport = this.$globals.airports.find(
        (airportItem) => airportItem.code === airportCode
      );

      if (!airport) return null;

      return airport.city + ", " + airport.state;
    },
    goToSeatMaps() {
      var details;
      details = {
        parent: this,
        component: SeatMapMenu,
        props: {
          activeTab: 0,
          flightProp: this.solution.journeys,
          preview: true,
        },
        hasModalCard: true,
        trapFocus: true,
      };
      this.$buefy.modal.open(details);
    },
    availableSeats(num) {
      if (num == "9") {
        return "9+";
      }
      return num;
    },
    checkScreenSize() {
      if (window.innerWidth <= 1023) {
        // console.log('window.innerWidth: ', window.innerWidth);
        this.isDesktop = false;
      }
    },
    checkSubmission() {

      if (this.solution.immediateTravelBookingAdvice == "warn") {
        this.$buefy.dialog.confirm({
          message:
            "You have selected a flight with a departure time in the next few hours. Please watch your email for your Final Ticketed Itinerary.  If you do not receive your Final Ticketed Itinerary, please contact Gant Travel Support at 877-924-0303 for assistance.   ",
          confirmText: "Continue booking",
          type: "is-info",
          hasIcon: true,
          onConfirm: () => this.submit(),
        });
      } else {
        this.submit();
      }
    },
    submit() {
      if (this.ndcFare) {
        let payload = {
          flight: this.solution,
          offer: this.solution.offer,
        };

        this.$store.dispatch("bookTravel/setNdcBooking", payload);

        //Exchange 

        if (this.$store.state.bookTravel.atc?.useAtcShopper) {
          this.$router.push({ name: "NdcReshopOptions" });
        } else {
          this.$router.push({ path: "ndc-fare-options" });
        }

      } else {
        this.$store.dispatch("bookTravel/alterResult", this.solution);

        if (this.pathMixin_isMeeting) {
          this.meetingRouter();
        } else if (this.$store.state.bookTravel.atc?.useAtcShopper) {
          this.$nav.pushRouteTo({ name: "ExchangeCheckout" });  
        } else {
          this.$nav.pushRouteTo({ name: "BookingItinerary" });
        }
      }
    },
  },
  mounted() {
    this.checkScreenSize();

    this.solution.unusedTicket = this.unusedTickets.includes(
      this.solution.journeys[0].airlineCode
    );
    for (var i = 0; i < this.solution.journeys.length; i++) {
      for (var j = 0; j < this.solution.journeys[i].legs.length; j++) {
        this.$set(this.solution.journeys[i].legs[j], "selectedSeat", false);
      }
    }
  },
};
</script>

<style lang="scss" scoped>
$scoreColors: (
  "10": #39996b,
  "9": #47ba41,
  "8": #abba19,
  "7": #f0dd01,
  "6": #ffce00,
  "5": #ffa600,
  "4": #ff7500,
  "3": #ff4e02,
  "2": #d21d00,
  "1": #a52620,
);
@each $score, $color in $scoreColors {
  .inner-circle {
    border-radius: 106%;
    display: inline-block;
    padding: 0;
    height: 26px;
    width: 26px;
    background: white;
  }
  .outer-circle-#{$score} {
    border-radius: 50%;
    display: inline-block;
    padding: 3px 2px 28px 2px;
    height: 32px;
    width: 32px;
    @if $score == "10" {
      background: linear-gradient(-20deg, $color 50%, transparent 0),
        /*adjust the deg value here to control the %*/
          linear-gradient(to right, $color 50%, transparent 0),
        $color;
    } @else if $score == "9" {
      background: linear-gradient(270deg, $color 50%, transparent 0),
        /*adjust the deg value here to control the %*/
          linear-gradient(54deg, $color 50%, transparent 0),
        white;
    } @else if $score == "8" {
      background: linear-gradient(270deg, $color 50%, transparent 0),
        /*adjust the deg value here to control the %*/
          linear-gradient(18deg, $color 50%, transparent 0),
        white;
    } @else if $score == "7" {
      background: linear-gradient(270deg, $color 50%, transparent 0),
        /*adjust the deg value here to control the %*/
          linear-gradient(-18deg, $color 50%, transparent 0),
        white;
    } @else if $score == "6" {
      background: linear-gradient(270deg, $color 50%, transparent 0),
        /*adjust the deg value here to control the %*/
          linear-gradient(-54deg, $color 50%, transparent 0),
        white;
    } @else if $score == "5" {
      background: linear-gradient(270deg, $color 50%, transparent 0),
        /*adjust the deg value here to control the %*/
          linear-gradient(-90deg, $color 50%, transparent 0),
        white;
    } @else if $score == "4" {
      background: linear-gradient(90deg, white 50%, transparent 0),
        /*adjust the deg value here to control the %*/
          linear-gradient(54deg, white 50%, transparent 0),
        $color;
    } @else if $score == "3" {
      background: linear-gradient(90deg, white 50%, transparent 0),
        /*adjust the deg value here to control the %*/
          linear-gradient(18deg, white 50%, transparent 0),
        $color;
    } @else if $score == "2" {
      background: linear-gradient(90deg, white 50%, transparent 0),
        /*adjust the deg value here to control the %*/
          linear-gradient(-18deg, white 50%, transparent 0),
        $color;
    } @else if $score == "1" {
      background: linear-gradient(90deg, white 50%, transparent 0),
        /*adjust the deg value here to control the %*/
          linear-gradient(-54deg, white 50%, transparent 0),
        $color;
    }
  }
  .score-#{$score} {
    //border: darken($color, 5) 2px solid;
    color: darken($color, 30);
    text-align: center;
    margin-left: 5px;
    font-weight: bold;
    font-size: 14px;
    line-height: 24px;
  }

  .score-bar-#{$score} {
    background-color: $color;
    text-align: center;
    width: 10px;
    height: 5px;
    display: inline-block;
    margin-left: 1px;
    font-weight: bold;
    font-size: 0;
    color: white;
  }
}
.active-score-bar {
  height: 20px;
  width: 20px;
  font-size: 12px;
  line-height: 20px;
}
.score-denominator {
  font-size: 10px;
  color: #aaa;
  display: none;

  &:before {
    content: "/";
    margin-left: 3px;
    margin-right: 3px;
    color: #ccc;
  }
}
.journey-details {
  //padding-left: 80px;
  padding: 0 5px;
  overflow-x: auto;
  overflow-y: hidden;
}

.columns.is-mobile > .column.is-narrow {
    flex: initial;
    width: unset;
}
</style>
